/* eslint-disable no-sequences */
/* eslint-disable func-names */
/* eslint-disable eqeqeq */
/* eslint-disable yoda */
/* eslint-disable no-void */
/* eslint-disable max-len */
/* eslint-disable prefer-reflect */
/* eslint-disable no-unused-expressions */

import { useEffect } from "react";
import { useHistory, useRouteMatch } from "react-router-dom";

import { hasPermissions } from "base/accessctrl";
import { getEnv } from "base/utils";
import {
  ADMIN_MODULE,
  ADMIN_RESOURCES,
  ADMIN_ACTIONS,
  ENV
} from "base/constants";
import { useUserStore } from "base/stores";

export const SUPPORT_CHANNELS = {
  INTERCOM: "intercom",
  SENTRY: "sentry"
};

export const SUPPORT_CHANNEL_INIT = {
  [SUPPORT_CHANNELS.INTERCOM]: (config = {}, onDone) => {
    function init() {
      try {
        var w = window;
        var ic = w.Intercom;
        if (typeof ic === "function") {
          ic("reattach_activator");
          ic("update", w.intercomSettings);
        } else {
          var d = document;
          var i = function getArgument() {
            i.c(arguments);
          };
          i.q = [];
          i.c = function getArgument(args) {
            i.q.push(args);
          };
          w.Intercom = i;
          var s = d.createElement("script");
          s.type = "text/javascript";
          s.defer = true;
          s.src = "https://widget.intercom.io/widget/" + config.intercomId;
          s.onload = onDone;
          var x = d.getElementsByTagName("script")[0];
          x.parentNode.insertBefore(s, x);
        }
      } catch (error) {
        console.error("Intercom failed to load", error);
      }
    }

    requestIdleCallback(() => init());
  },
  [SUPPORT_CHANNELS.SENTRY]: (config = {}, onDone) => {
    function init() {
      import("@sentry/react")
        .then(function onLoadSentry(Sentry) {
          Sentry.init({
            dsn: config.url,
            integrations: [
              Sentry.reactRouterV5BrowserTracingIntegration({
                history: config.history
              })
            ],
            tracePropagationTargets: [],
            tracesSampleRate: 0.02,
            transport: Sentry.makeBrowserOfflineTransport(
              Sentry.makeFetchTransport
            )
          });
          const scope = Sentry.getCurrentScope();
          scope.setTag("domain", window.location.origin);
          scope.setTag("platform", config.platform);
          scope.setTag("accountId", config.accountId);
          scope.setUser(config.user);
        })
        .catch((err) => {
          console.error("Failed to load sentry ", err);
        });
    }

    requestIdleCallback(() => init());
  }
};

export function getSupportConfig(supportChannel) {
  const envConfig = {
    [ENV.PRD]: {
      [SUPPORT_CHANNELS.INTERCOM]: { intercomId: "i4o64ynd" },
      [SUPPORT_CHANNELS.SENTRY]: {
        url: "https://ca7d74b92f294b41887b1ff7ac69798a@o300529.ingest.sentry.io/6056533"
      }
    },
    [ENV.UAT]: {
      [SUPPORT_CHANNELS.INTERCOM]: { intercomId: "ir4zvnc7" },
      [SUPPORT_CHANNELS.SENTRY]: {
        url: "https://94836069752443a68095a4896589dcc4@o300529.ingest.sentry.io/6056536"
      }
    }
  };

  return (
    envConfig[getEnv()]?.[supportChannel] ||
    envConfig[ENV.UAT]?.[supportChannel]
  );
}

export const Intercom = () => {
  let match = useRouteMatch();

  useEffect(function loadIntercom() {
    let config = getSupportConfig(SUPPORT_CHANNELS.INTERCOM);

    const INTERCOM_USER_ROLE = {
      UserAdmin: hasPermissions({
        module: ADMIN_MODULE,
        resource: ADMIN_RESOURCES.USER_MANAGEMENT,
        actions: [ADMIN_ACTIONS.UPDATE]
      }),
      BillingAdmin: hasPermissions({
        module: ADMIN_MODULE,
        resource: ADMIN_RESOURCES.BILLING,
        actions: [ADMIN_ACTIONS.READ]
      }),
      IAMAdmin: hasPermissions({
        module: ADMIN_MODULE,
        resource: ADMIN_RESOURCES.USER_PROVISIONING,
        actions: [ADMIN_ACTIONS.UPDATE]
      }),
      AppStoreAdmin: hasPermissions({
        module: ADMIN_MODULE,
        resource: ADMIN_RESOURCES.APPSTORE,
        actions: [ADMIN_ACTIONS.INSTALL]
      })
    };
    let userRole = Object.keys(INTERCOM_USER_ROLE)
      .filter((key) => INTERCOM_USER_ROLE[key])
      .join("-");

    let userJson = useUserStore.getState().currentUser;
    let licenseInfo = userJson.AccountDetails.LicenseInfo;
    let isAdmin = useUserStore.getState().isSuperAdmin();

    let intercom = SUPPORT_CHANNEL_INIT[SUPPORT_CHANNELS.INTERCOM];

    intercom({ intercomId: config.intercomId }, () => {
      window.Intercom("boot", {
        app_id: config.intercomId,
        vertical_padding: 140,
        hide_default_launcher: true,
        user_id: userJson._id,
        email: userJson.Email,
        //custom attributes
        name: userJson.Name,
        first_name: userJson.FirstName,
        last_name: userJson.LastName,
        user_role: userRole,
        domain: userJson.AccountDetails.Domain,
        plan_type: licenseInfo.Plan,
        plan_status: licenseInfo.Status,
        plan_due_date: licenseInfo.NextDue,
        plan_subscription_date: licenseInfo.PurchasedAt,
        company_id: userJson.AccountDetails._id,
        company_name: userJson.AccountDetails.Name,
        kissflow_product: licenseInfo.Product,
        product_last_seen: parseInt(new Date().getTime() / 1000, 10),
        product_language: userJson.Language.Name,
        kissflow_version: "kf4",
        isAdmin: isAdmin,
        company: {
          id: userJson.AccountDetails._id,
          name: userJson.AccountDetails.Name,
          domain: userJson.AccountDetails.Domain,
          plan_type: licenseInfo.Plan,
          plan_status: licenseInfo.Status,
          kissflow_product: licenseInfo.Product,
          kissflow_version: "kf4",
          product_language: userJson.AccountDetails.Language.Name
        }
      });
    });
  }, []);

  useEffect(
    function checkIfRouteChanged() {
      if (window.Intercom) {
        // eslint-disable-next-line radix
        window.Intercom("update", {
          last_request_at: parseInt(new Date().getTime() / 1000, 10),
          hide_default_launcher: true
        });
      }
    },
    [match.url]
  );

  return null;
};

export const Sentry = () => {
  let history = useHistory();

  useEffect(function initilizeSentry() {
    let config = getSupportConfig(SUPPORT_CHANNELS.SENTRY);

    let userJson = useUserStore.getState().currentUser;

    let sentry = SUPPORT_CHANNEL_INIT[SUPPORT_CHANNELS.SENTRY];

    sentry({
      url: config.url,
      history: history,
      endpoint: userJson.AccountDetails.Endpoint,
      accountId: userJson.AccountDetails._id,
      user: {
        id: userJson._id
      },
      // eslint-disable-next-line no-undef
      platform: PLATFORM_TYPE
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
};
